<template>
    <div class="header">
        <el-row class="flex items-center" align="middle">
            <el-col :span="8">
                <div class="header-left">
                    <i :class="userStore.isCollapse ? 'el-icon-s-fold' : 'el-icon-s-unfold'" @click="menuCollapse"></i>
                    <i class="el-icon-full-screen" @click="fullscreen.toggle"></i>
                </div>
            </el-col>
            <el-col :span="8">
                <div class="header-title">君畅智达出行服务平台-租赁公司端</div>
            </el-col>
            <el-col :span="8">
                <div class="header-right">
                    <img class="header-avatar" :src="userInfo.headImg" alt="">
                    <div class="header-name truncate">你好，{{ userInfo.userNickName || '' }}</div>
                    <el-button size="mini" plain @click="logout">退出</el-button>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import { useFullscreen } from '@vueuse/core';
import useUserStore from '@/store/user';

export default {
    data() {
        return {
            
        }
    },
    computed: {
        fullscreen() {
            return useFullscreen();
        },
        userStore() {
            return useUserStore();
        },
        userInfo() {
            return this.userStore.userInfo;
        },
    },
    methods: {
        logout() {
            this.$confirm('确定注销并退出系统吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // location.href = '/login';
                this.userStore.logOut().then(() => {
                    location.href = '/login';
                })
            }).catch(() => { });
        },
        menuCollapse() {
            this.userStore.isCollapse = !this.userStore.isCollapse;
        },
    },
}
</script>
<style lang="scss" scoped>
.header {
    display: flex;
    align-items: center;
    width: 100%;
    color: #ffffff;
    background: $theme;
    height: 60px;
    padding: 0 20px;
    .el-row {
        width: 100%;
    }
    &-left {
        display: flex;
        align-items: center;
        i {
            font-size: 20px;
            cursor: pointer;
            &:hover {
                opacity: .8;
            }
            + i {
                margin-left: 20px;
            }
        }
    }
    &-title {
        font-size: 20px;
        text-align: center;
    }
    &-right {
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }
    &-name {
        margin: 0 10px;
    }
    &-avatar {
        border-radius: 50%;
        width: 30px;
        height: 30px;
    }
}
</style>
